<template>
  <button
    :type="type"
    class="btn mb-0"
    :class="getClasses(variant, color, size, fullWidth, active)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "MaterialButton",
  props: {
    color: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "fill", // "fill" | "outline" | "gradient" | "text"
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "submit",
    },
  },
  methods: {
    getClasses: (variant, color, size, fullWidth, active) => {
      let colorValue, sizeValue, fullWidthValue, activeValue;

      // Handle different button variants
      if (variant === "gradient") {
        colorValue = `bg-gradient-${color}`;
      } else if (variant === "outline") {
        colorValue = `btn-outline-${color}`;
      } else if (variant === "text") {
        // text-only button (no bg, no border, just text color)
        colorValue = `btn-text text-${color}`;
      } else {
        colorValue = `btn-${color}`;
      }

      sizeValue = size ? `btn-${size}` : null;
      fullWidthValue = fullWidth ? `w-100` : null;
      activeValue = active ? `active` : null;

      return `${colorValue} ${sizeValue} ${fullWidthValue} ${activeValue}`;
    },
  },
};
</script>

<style>
/* Custom style for text-only button */
.btn-text {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  text-decoration: none !important;
  padding: 0.375rem 0.75rem; /* keep spacing like normal button */
}

.btn-text:hover {
  background: rgba(0, 0, 0, 0.04); /* subtle hover effect */
}
</style>
